import React from 'react';
import { Icon as SUIIcon, IconProps as SUIIconProps } from 'semantic-ui-react';

export type IconProps = SUIIconProps & {};

const Icon: React.FC<IconProps> = ({ ...rest }) => <SUIIcon {...rest} />;

export default Icon;
